// import './whyDidYouRender'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { Amplify } from 'aws-amplify'
// eslint-disable-next-line
import Symbol_observable from 'symbol-observable' // fix for redux-toolkit not updating the store
import 'url' // fix issue for newer webpack missing url polyfill

import * as Sentry from '@sentry/react'

import store from './store'
import './i18n'

import App from './features/components/App/index'
import StylesProvider from './features/components/App/StylesProvider'

import { REACT_APP_ENVIRONMENTS } from './constants/other'

const productionPool = {
  region: 'us-east-1',
  //  Amazon Cognito User Pool ID
  userPoolId: 'us-east-1_GBQpCy9rX',
  userPoolClientId: '7n1dkh45aeafjrv2bogvipuv7e'
}

const developmentPool = {
  region: 'us-east-1',
  //  Amazon Cognito User Pool ID
  userPoolId: 'us-east-1_mQc0kgXT9',
  userPoolClientId: '23u65a656tahvuvf95knfmmtov'
}

Amplify.configure({
  Auth: {
    Cognito: process.env.REACT_APP_ENVIRONMENT === REACT_APP_ENVIRONMENTS.prod ? productionPool : developmentPool
  }
})

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      // Add browser profiling integration to the list of integrations
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration()
    ],
    environment: process.env.REACT_APP_ENVIRONMENT,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0
  })

  const { replayIntegration } = await import('@sentry/browser')
  // lazyload the replay integration to speed up initial app load
  Sentry.addIntegration(
    replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
      // Capture Replay for 0% of all sessions,
      replaysSessionSampleRate: 0,
      // but 100% of sessions with an error
      replaysOnErrorSampleRate: 1.0
    })
  )
}

const container = document.getElementById('root')
const root = createRoot(container)
const queryClient = new QueryClient()

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <StylesProvider>
        <App />
      </StylesProvider>
    </Provider>
  </QueryClientProvider>
)

export { getTotalBudgetInDigitalRight } from './helpers/other'
